import React from "react"
import {useTranslation} from "react-i18next"

import {IonButton, IonIcon, useIonAlert} from "@ionic/react"

import {usePersonGroups as useItems} from "../../../contexts/PersonGroupContext"

import PersonGroup                from "../../../types/PersonGroup"
import {trashOutline, trashSharp} from "ionicons/icons";

interface props {
    personGroup:                          PersonGroup
    setSelectedLockingSystemPermissions?: any
}

const ButtonDeleteAll: React.FC<props> = ({personGroup, setSelectedLockingSystemPermissions}: props) => {

    const { t } = useTranslation()
    const [ presentAlert ] = useIonAlert()

    const {deleteAllPermissions} = useItems()

    const alertDeleteAll = (ev: any) => {
        return presentAlert({
            header:  t('personGroupLockingSystemPermissions.alerts.delete_all.header'),
            message: t('personGroupLockingSystemPermissions.alerts.delete_all.message'),
            buttons: [{
                text: t('common.cancel'),
                role: 'cancel',
            }, {
                text: t('common.continue'),
                role: 'confirm',
                handler: () => onDeleteAll(),
            },]
        })
    }

    const onDeleteAll = async () => {
        await deleteAllPermissions(personGroup)
    }

    return (
        <IonButton color="danger" fill="clear" onClick={(ev) => alertDeleteAll(ev)}
                   size="small" type="button">
            <IonIcon slot="start" ios={trashOutline} md={trashSharp} />
            {t('common.remove_all_permissions')}
        </IonButton>
    )
}

export default ButtonDeleteAll
